import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'AppgColumn',
  props: ['minWidth', 'maxWidth', 'align', 'fixed', 'sortable'],
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      return _openBlock(), _createBlock(_component_el_table_column, {
        "min-width": __props.minWidth,
        "max-width": __props.maxWidth,
        align: __props.align,
        fixed: __props.fixed,
        sortable: __props.sortable ?? false
      }, {
        header: _withCtx(() => [_renderSlot(_ctx.$slots, "tableHeader")]),
        default: _withCtx(({
          row,
          $index
        }) => [_renderSlot(_ctx.$slots, "tableBody", {
          row: row,
          index: $index
        })]),
        _: 3
      }, 8, ["min-width", "max-width", "align", "fixed", "sortable"]);
    };
  }
};